<template lang="pug">
  v-layout.box-canal-formatter(column)
    v-flex.only-desktop(style="position:relative")
      v-layout(column)
        v-flex(style="height:150px")
          v-img
            img(style="display: flex" :src="iconPerson")
        v-flex(style="position: absolute;right: -50px;top: 40px;")
          v-flex.box-text-icon-canal-formatter
            span(style="color:#ffffff")
          v-img
            img(style="display: flex;width:7.5em" :src="nubeTexto")
    v-flex
      v-layout.list(column)
        v-flex
          v-layout(row)
            v-flex(style="max-width: 3em;width: 3em;line-height: 0;")
              v-img
                img(:src="iconChat" style="height:1.5em; width:1.5em")
            v-flex(style="align-self: center;")
              a(:href="links.WhatsApp" target="_blank" style="color: #0855C4;") Canales Digitales
        v-flex
          v-layout(row)
            v-flex(style="max-width: 3em;width: 3em;line-height: 0;")
              v-img
                img(:src="iconWeb" style="height:1.5em; width:1.5em")
            v-flex(style="align-self: center;")
              a(:href="links.Home"  target="_blank" style="font-style: italic;") www.interseguro.pe
        v-flex
          v-layout(row)
            v-flex(style="max-width: 3em;width: 3em;line-height: 0;")
              v-img
                img(:src="iconTelephone" style="height:1.5em; width:1.5em")
            v-flex(style="align-self: center;")
              a(style="text-decoration: none;") (01) 500 - 0000
</template>

<script>
import * as d3 from 'd3'
import { mapActions } from 'vuex'
import Links from '../../interfaces/links'

export default {
  props: [
    'taggeo'
  ],
  data () {
    return {
      links: Links,
      iconPerson: require('@/assets/icons-mis-seguros/icono-mi-agente2.svg'),
      nubeTexto: require('@/assets/icons-mis-seguros/icono-nube.svg'),
      iconChat: require('@/assets/icons/icon-chat.svg'),
      iconWeb: require('@/assets/icons/icon-web.svg'),
      iconTelephone: require('@/assets/icons/icon-telephone.svg')
    }
  },
  mounted () {
    let self = this

    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Mis canales', metadata})

    d3.select('.box-canal-formatter')
      .style('opacity', '0')
      .transition().duration(300)
      .style('opacity', '1')

    d3.select('.box-text-icon-canal-formatter span')
      .style('opacity', '0')
      .style('font-size', '11px')
      .style('color', '#ffffff')
      .text('Aquí encontrarás nuestros canales de atención')
      .transition().duration(1500)
      .style('opacity', '1')

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'seccion': 'mis canales'
      }
    })
  },
  methods: {
    ...mapActions('event', ['eventLog'])
  }
}
</script>

<style scoped>

.box-canal-formatter {
  margin-top: 1em;
  margin-left:3px;
}

.box-canal-formatter .box-text-icon-canal-formatter {
  position: absolute;
  z-index: 99;
  top: 3px;
  left: 8px;
  height: 3em;
  width: 6.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  text-align: center;
}

.list > div:not(:first-child) {
  margin-top: 1.5em;
}

a {
  font-size: 14px;
  color: var(--text-color);
}

@media screen and (min-width: 992px) {
  .box-canal-formatter {
    margin-top: 3.5rem;
    margin-bottom: 5rem;
    align-items: center;
    gap: 30px;
  }

  .list > div.flex {
    margin-top: 1.4em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/MisCanales.vue